import { Component } from '@angular/core';

import { PlayersPage } from '../players/players';
import { ContactPage } from '../contact/contact';
import { SettingsPage } from '../settings/settings';
import { Rounds } from '../rounds/rounds';
import { Standings } from '../standings/standings';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tab1Root = Rounds;
  tab2Root = Standings;
  tab3Root = SettingsPage;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts